import find from "lodash/find";
import includes from "lodash/includes";
import map from "lodash/map";
import { ShortlistForProfileButton } from "PFApp/profiles/shortlist_for_profile";
import { ColumnHelper } from "PFComponents/table/table.types";
import { MatchedProfile, OrderOption, TableColumn } from "PFCore/types";
import { useCallback } from "react";

import { useProfilesPageContext } from "../../context";
import css from "./profiles_table.module.scss";
import { useCellFactory } from "./use_cell_factory";

const COLUMNS_SIZE = {
  1: 100,
  2: 180,
  3: 300
};

const getColumnConfig = (column: TableColumn, orderOptions: OrderOption[]) => ({
  id: column.name,
  header: column.title,
  enableSorting:
    !!column.orderKey && !!find(orderOptions, (option) => includes(option.name, column.orderKey)),
  size: COLUMNS_SIZE[column.size || 2]
});

export const useGenerateProfilesTableColumns = () => {
  const { selectedColumns } = useProfilesPageContext();
  const renderCell = useCellFactory();

  const generateColumns = useCallback(
    (columnHelper: ColumnHelper<MatchedProfile>) => [
      ...map(selectedColumns, (column) =>
        columnHelper.accessor(({ profile }) => profile, {
          ...getColumnConfig(column, []),
          cell: renderCell(column)
        })
      ),
      columnHelper.accessor(({ profile }) => profile, {
        id: "shortlistAction",
        header: "",
        cell: ({ getValue }) => (
          <div className={css.shortlistButtonCell}>
            <ShortlistForProfileButton className={css.shortlistButton} profile={getValue()} small />
          </div>
        ),
        enableSorting: false,
        meta: {
          sticky: true,
          headerClassName: css.header
        }
      })
    ],
    [selectedColumns, renderCell]
  );

  return generateColumns;
};
